<template>
  <v-container>
    <div class="text-right"><PeopleSort @update="fetchData()" /></div>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:item.student="{ item }">
        <PersonItem small flags :value="item" />
      </template>
      <template v-slot:item.bilingual.code="{ item }">
        <LookupValue short :value="item.bilingual" />
      </template>
      <template v-slot:item.artsSubject.code="{ item }">
        <LookupValue short :value="item.artsSubject" />
      </template>
      <template v-slot:item.thirdLanguage.code="{ item }">
        <LookupValue short :value="item.thirdLanguage" />
      </template>
      <template v-slot:item.majorSubject.code="{ item }">
        <LookupValue short :value="item.majorSubject" />
      </template>
      <template v-slot:item.majorSubjectPlus.code="{ item }">
        <LookupValue short :value="item.majorSubjectPlus" />
      </template>
      <template v-slot:item.complementarySubject.code="{ item }">
        <LookupValue short :value="item.complementarySubject" />
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper.js";
import PersonItem from "common/components/PersonItem.vue";
import PeopleSort from "@/components/settings/PeopleSort.vue";
import LookupValue from "common/components/LookupValue.vue";
import { sortPeople } from "common/utils/people.js";

export default defineComponent({
  name: "CourseList",
  components: { LookupValue, PersonItem, PeopleSort },
  props: ["id"],
  data() {
    return {
      course: {},
      loading: false,
      items: [],
      headers: [
        { text: "Schüler*in", value: "student", sortable: false },
        { text: "BI", value: "bilingual.code" },
        { text: "KU", value: "artsSubject.code" },
        { text: "S3", value: "thirdLanguage.code" },
        { text: "SF", value: "majorSubject.code" },
        { text: "SF+", value: "majorSubjectPlus.code" },
        { text: "EF", value: "complementarySubject.code" },
      ],
    };
  },
  methods: {
    async fetchData() {
      if (this.id > 0) {
        this.loading = true;
        this.course = await this.apiGet({
          resource: "course/coursepart",
          id: this.id,
        });
        this.items = sortPeople(this.course.students);
        this.loading = false;
      }
    },
  },
  watch: {
    async id() {
      await this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
